<template>
  <modal v-model="show"
         max-width="500"
         contentClass="modal-visible"
         @input="onInput">

    <app-button v-if="!noActivator"
                class="access-point-controller-create-activator btn btn-round btn-primary"
                slot="activator"
                :label="$t('message.voucher.message.segments.create')"                
                @click="openModal">

    </app-button>

    <div class="voucher-segment-create-modal-body">
      <app-form class="voucher-segment-create-modal-body-form"
                @submit="createVoucherSegment"
                ref="form">
        <h1 class="text-muted text-center">
          {{ title }}
        </h1>

        <text-field v-model="form.name"
                    label="Nome da segmentação"
                    name="Nome"                    
                    validate="required" />       
                    
        <checkbox v-model="form.onceTimePerDay"
                  label="Uso diário único"
                  name="Uso diário único"
                  center />

        <app-select v-model="form.type"
                    class="voucher-segment-create-modal-body-form-select"
                    data-title="Tipo"
                    data-menu-heading="Tipo"
                    data-menu-width="290px"
                    :data-button-gradient="true"
                    :data-items="typeOptions"
                    :data-search="false"
                    :disabled="isEdit"
                    center />

        <app-button class="voucher-segment-create-modal-body-form-action btn btn-round btn-primary"
                    :label="isEdit ? $t('message.generics.message.edit') : $t('message.generics.message.add')"
                    type="submit"
                    >
        </app-button>

      </app-form>
    </div>

  </modal>
</template>

<script>
import AppForm from "@components/form/Form.vue";
import TextField from "@components/form/TextField.vue";
import AppSelect from "@components/Select";
import Checkbox from "@components/Checkbox";
import AppButton from "@/components/generic/button/Button";
import Modal from "@/components/generic/Modal";
import EventBus from "@packages/event-bus";

export default {
  components: {
    Modal,
    AppButton,
    Checkbox,
    AppSelect,
    TextField,
    AppForm,
  },

  data() {
    return {
      show: false,
      typeOptions: [
        {
          id: "VOUCHER_CODE",
          label: "Voucher",
        },
        {
          id: "LOGIN_AND_PASSWORD",
          label: "Login e senha",
        },
      ],
      form: {
        name: undefined,
        type: undefined,
        onceTimePerDay: false,
      },
    };
  },

  mixins: [],

  props: {
    noActivator: {
      type: Boolean,
      default: false,
    },
    manualShow: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
    },
  },

  watch: {
    manualShow(showVal) {
      this.show = showVal;      

      if (showVal && this.isEdit) {
        this.setItemData();
      }
    },
    show(showing) {
      if(showing) {
        this.resetValidation()
      }
    }
  },

  methods: {
    onInput(isModalOpen) {
      if (isModalOpen !== this.manualShow) {
        if (isModalOpen) {
          this.openModal();
        } else {
          this.closeModal();
        }
      }
    },
    setItemData() {
      this.form = {
        name: this.item.name,
        type: this.item.type,
        onceTimePerDay: this.item.onceTimePerDay,
      };
    },
    openModal() {
      if (this.manualShow) {
        this.$emit("update:manualShow", true);
      } else {
        this.show = true;
      }

      if (this.isEdit) {
        this.setItemData();
      }
    },
    closeModal() {
      if (this.manualShow) {
        this.$emit("update:manualShow", false);
      } else {
        this.show = false;
      }
    },
    hasValidType() {
      const isValidType =
        this.form.type !== undefined && this.form.type !== null;

      if (!isValidType) {
        EventBus.$emit("show-message", {
          type: "ERROR",
          message: "O campo Tipo é obrigatório",
        });
      }

      return isValidType;
    },
    async createVoucherSegment() {
      const isValidType = this.hasValidType();

      if (isValidType) {
        if (this.isEdit) {
          await this.$api.core.voucher.segment.update({
            name: this.form.name,
            onceTimePerDay: this.form.onceTimePerDay,
            segmentId: this.item.id,
          });

          EventBus.$emit("show-message", {
            type: "SUCCESS",
            message: "Segmentação editada com sucesso!",
          });
        } else {
          await this.$api.core.voucher.segment.create({
            name: this.form.name,
            type: this.form.type,
            onceTimePerDay: this.form.onceTimePerDay,
          });

          EventBus.$emit("show-message", {
            type: "SUCCESS",
            message: "Segmentação criada com sucesso!",
          });
        }

        EventBus.$emit("VOUCHER_SEGMENT_CREATED");

        this.closeModal();
        this.resetData()
      }
    },
    resetData() {
      this.form = {
        name: undefined,
        type: undefined,
        onceTimePerDay: false,
      }
    },
    resetValidation() {
      this.$refs.form.reset();
    },
  },

  computed: {
    isEdit() {
      return !!this.item;
    },
    title() {
      return this.isEdit
        ? `Editar Segmentação`
        : this.$t("message.voucher.message.segments.create");
    },
  },
};
</script>

<style lang="scss" scoped>
.voucher-segment-create-modal-body {
  .voucher-segment-create-modal-body-form {
    .voucher-segment-create-modal-body-form-select {
      margin: 0 auto;
    }

    .voucher-segment-create-modal-body-form-action {
      margin: 0 auto;
      margin-top: 40px;
    }
  }
}
</style>